import { render, staticRenderFns } from "./FoodRow.vue?vue&type=template&id=d568b2fa&scoped=true"
import script from "./FoodRow.vue?vue&type=script&lang=js"
export * from "./FoodRow.vue?vue&type=script&lang=js"
import style0 from "./FoodRow.vue?vue&type=style&index=0&id=d568b2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d568b2fa",
  null
  
)

export default component.exports